/**
 * NotFound Component - Desktop 404 Page
 * 
 * Professional 404 page for desktop users with IFIA branding
 * Provides clear messaging and navigation options
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faArrowLeft, faExclamationTriangle, faSearch } from '@fortawesome/free-solid-svg-icons';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSearch = () => {
    navigate('/Search');
  };

  const publicPages = [
    "/auth/login",
    "/auth/register",
    "/auth/forgotpassword",
  ];

  if (publicPages.includes(location.pathname.toLowerCase())) {
    navigate('/');
    return;
  }

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-header">
          <div className="not-found-icon">
            <FontAwesomeIcon icon={faExclamationTriangle} />
          </div>
          <h1 className="not-found-title">Page Not Found</h1>
          <div className="not-found-code">404</div>
        </div>

        <div className="not-found-message">
          <p>We couldn't find the page you're looking for:</p>
          <div className="not-found-path">
            <code>{location.pathname}</code>
          </div>
          <p>The page may have been moved, deleted, or you may have typed the URL incorrectly.</p>
        </div>

        <div className="not-found-suggestions">
          <h3>What you can do:</h3>
          <ul>
            <li>Check the URL for typing errors</li>
            <li>Use the search function to find what you're looking for</li>
            <li>Go back to the previous page</li>
            <li>Return to the home page</li>
          </ul>
        </div>

        <div className="not-found-actions">
          <button 
            className="not-found-btn not-found-btn-primary"
            onClick={handleGoHome}
          >
            <FontAwesomeIcon icon={faHome} />
            Go to Home
          </button>
          
          <button 
            className="not-found-btn not-found-btn-secondary"
            onClick={handleGoBack}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            Go Back
          </button>
          
          <button 
            className="not-found-btn not-found-btn-secondary"
            onClick={handleSearch}
          >
            <FontAwesomeIcon icon={faSearch} />
            Search
          </button>
        </div>

        <div className="not-found-footer">
          <p>If you continue to experience issues, please contact support.</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 